/**
 * Created by Bart Decorte
 * Date: 25/06/2020
 * Time: 10:04
 */
import Page from '../Page';

export default class UsersApps extends Page {}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Users/UsersApps.js